import React from 'react';

const AI_GENERATED_ASSETS = new Set([
    '/images/studio-web-seeschloss-live-v5.webp',
    '/images/website-design-review-meeting-room-v5.jpg',
    '/images/studio-seo-private-analytics-v3.jpg',
    '/images/studio-mod-development-v4.webp',
    '/images/studio-web-v2.webp',
    '/images/studio-seo-v2.webp',
    '/images/studio-mods-v2.webp',
    '/images/products/product-studio-hero-v3.webp',
    '/images/products/product-web-v3.webp',
    '/images/products/product-seo-v3.webp',
    '/images/products/product-automation-v3.webp',
    '/images/products/product-gameserver-v3.webp',
    '/images/products/product-multiplayer-v3.webp',
]);

const PUBLIC_ORIGIN = 'https://core-labs.de';
export const DEFAULT_SOCIAL_IMAGE = `${PUBLIC_ORIGIN}/og.png`;

export const isAiGeneratedAsset = src => {
    try {
        return AI_GENERATED_ASSETS.has(new URL(src, 'https://core-labs.invalid').pathname);
    } catch {
        return false;
    }
};

export const getPublicSocialImage = src => {
    if (!src || isAiGeneratedAsset(src)) return DEFAULT_SOCIAL_IMAGE;
    try {
        const url = new URL(src, PUBLIC_ORIGIN);
        return ['http:', 'https:'].includes(url.protocol) ? url.href : DEFAULT_SOCIAL_IMAGE;
    } catch {
        return DEFAULT_SOCIAL_IMAGE;
    }
};

export function AiImageDisclosure({ language = 'de' }) {
    const german = language === 'de';
    const description = german
        ? 'Dieses Bild wurde mit generativer KI erstellt oder bearbeitet.'
        : 'This image was created or edited with generative AI.';

    return (
        <span className="ai-generated-label" role="note" aria-label={description} title={description}>
            {german ? 'KI-generiert' : 'AI-generated'}
        </span>
    );
}
